var map = {
	"./checkbox-true.svg": "7kqe",
	"./radio-true.svg": "xccc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Id76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\-true\.svg$
// module id = Id76
// module chunks = 26